import React from 'react'
import {Link} from 'react-router'
import {prefixLink} from 'gatsby-helpers'
import {config} from 'config'

import '../static/css/reset.css'
import '../static/css/typography.css'
import '../static/css/w3.css'
import '../static/css/base.css'
import '../static/css/animate.css'
import '../static/css/aos.css'
import '../static/css/devicons.css'

class Template extends React.Component {

    render() {
        const {location, children, AOS} = this.props
        return (
            <div>
                <div className='wrapper'>
                    {children}
                </div>
            </div>
        );
    }

    componentDidMount() {
        const AOS = require('aos');
        this.aos = AOS
        this.aos.init({duration: 1200})
    }

    componentDidUpdate() {
        this.aos.refresh()
    }
}

Template.propTypes = {
    children: React.PropTypes.any,
    location: React.PropTypes.object,
    route: React.PropTypes.object
}

export default Template



// WEBPACK FOOTER //
// ./_template.jsx